  'use strict';

angular.module('atex.dam').factory('DamFoldersNode', function() {

  var DamFoldersNode = function(parentNode, id, name, owners, smartFolder) {
    this.id = id;
    if (name) {
      this.name = name;
    } else {
      this.name = 'no name';
    }
    this.owners = owners;
    this.collapsed = true;
    if (parentNode) {
      this.parentNode = parentNode;
      parentNode.children = parentNode.children || (parentNode.children = []);
      parentNode.children.push(this);
    }
    this.smartFolder = smartFolder;
    this.folderClosedIconClass = this.smartFolder ? 'fa fa-folder-o' : 'fa fa-folder';
    this.folderOpenIconClass = this.smartFolder ? 'fa fa-folder-open-o' : 'fa fa-folder-open';
    this.types = [];
  };

  DamFoldersNode.prototype.buildPath = function() {
    var folders = [this.name];
    var parent = this.parentNode;
    while(parent && !parent.isRoot) {
      folders.push(parent.name);
      parent = parent.parentNode;
    }
    folders.reverse();
    return folders.join("/");
  };

  DamFoldersNode.prototype.getPhysicalParent = function() {
    if (!this.smartFolder) {
      return this;
    }
    var parent = this.parentNode;
    while(parent && !parent.isRoot) {
      if (!parent.smartFolder) {
        return parent;
      }
      parent = parent.parentNode;
    }
    return;
  };

  DamFoldersNode.prototype.setTypes = function(array) {
    this.types = array;
  };

  DamFoldersNode.prototype.getAllowedTypes = function() {
    if (!this.smartFolder) {
      return this.types;
    }
    // If smart lookup on the parents (smart and physical if exits)
    var currentTypes = angular.copy(this.types);
    var parent = this.parentNode;
    var typesAreFromPhys = false;
    while(parent && currentTypes.length<=0) {
      typesAreFromPhys = !parent.smartFolder;
      currentTypes = parent.types;
      parent = parent.parentNode;
    }
    if (!typesAreFromPhys) {
      // Check also the types from PhysicalParent
      var physParent = this.getPhysicalParent();
      if (physParent) {
        // Check both arrays....
        var physTypes = angular.copy(physParent.types);
        if (physTypes.length>0) {
          // Return physTypes that are also in the smartTypes
          for (var i = physTypes.length-1; i>=0; i--) {
            if (_.indexOf(currentTypes, physTypes[i]) === -1) {
              physTypes.splice(i, 1);
            }
          }
          currentTypes = physTypes;
        }
      }
    }
    return angular.copy(currentTypes);
  };

  return DamFoldersNode;
});

angular.module('atex.dam').service('DamFoldersService', ['$q', '$rootScope', 'DamFoldersNode', 'DamService', 'DamSearchService', 'ContentService', 'SearchService', 'AssignService', '$translate', 'DamNotificationService', 'DamActivityService', 'configuration', 'DamLocalizationService', 'ApplicationConfigurationService',
function($q, $rootScope, DamFoldersNode, DamService, DamSearchService, ContentService, SearchService, AssignService, $translate, DamNotificationService, DamActivityService, configuration, DamLocalizationService, ApplicationConfigurationService) {

  var self = this;
  var initInProgress = false;

  // keep model for DamFoldersController
  self.rootNode = {};
  self.hideRoot = true;
  self.treemodel = [];
  self.selectedNode = {};
  self.userInfo = {};
  // keep also a separated model for DamMoveToFolderModalController
  self.moveRootNode = {};
  self.moveTreemodel = [];
  self.moveSelectedNode = {};

  self.listingFolder = undefined;

  var _escape = function(toescape) {
    var value = DamService.escapeLucene(toescape);
    return value.replace(new RegExp(' ', 'g'), '\\ ');
  };

  // Modify
  self.resetTree = function()  {
    this.selectedNode = undefined;
    self.treemodel.length = 0;
    self.moveSelectedNode = undefined;
    self.moveTreemodel.length = 0;
  };

  self.setUserInfo = function(userInfo) {
    self.userInfo = userInfo;
  };

  self.resetValues = function() {
    self.userInfo = undefined;
    if (self.rootNode) {
      self.rootNode.collapsed = true;
      if (self.rootNode.children) {
        self.rootNode.children.length = 0;
      }
    }
    self.resetTree();
  };

  self.getMaxFolders = function() {
    return ApplicationConfigurationService.getConfigurationFor([ 'maxSubFoldersSize' ]).then(function(data) {
      return data || 100;
    });
  };

  self.searchSubFolders = function(folderId) {
    return DamService.getCurrentDamUserInfo().then(function(currentUserInfo) {
      self.setUserInfo(currentUserInfo);
      return self.getMaxFolders().then(function (maxRows) {
        return DamService.getSolrServerInfo().then(function(solrInfo) {
          return _.extend({maxRows: maxRows}, solrInfo);
        });
      });
    }).then(function(solrInfo) {
      var transferInfo = {};
      transferInfo['variant'] = 'list';
      transferInfo['fl'] = 'id';
      // AMS-6252 - let the max number of results being configurable.
      transferInfo['rows'] = solrInfo.maxRows;
      transferInfo['core'] = solrInfo.solrCore;
      transferInfo['q'] = '+atex_desk_objectType:(folder)';
      transferInfo['q'] += '+parent_atex_desk_ss:(' + _escape(folderId) + ')';
      if (!self.userInfo.isAdm) {
        transferInfo['q'] += '+assignees_atex_desk_sms:(';
        transferInfo['q'] += self.userInfo.externalId;
        for (var i=0; self.userInfo.groups && i<self.userInfo.groups.length;i++) {
          var escaped = self.userInfo.groups[i].principalId.replace(':', '\\:');
          transferInfo['q'] += ' OR ' + escaped;
        }
        transferInfo['q'] += ')';
      }
      transferInfo['sort'] = "name_atex_desk_ss asc";
      return SearchService.search(transferInfo);
    });
  };

  self.expandNode = function(node) {
    if (node.children) {
      node.children.length = 0;
    }
    return self.searchSubFolders(node.id).then(function(response) {
      // AMS-6252
      // if there are more results (numFound) that the searched ones we should emit a warning
      // in the console to let the user know there are more folders than the limit we have.
      self.getMaxFolders().then(function(maxRows) {
        if ((response.data.response.numFound || 0) > maxRows) {
          console.warn('We found ' + response.data.response.numFound +
            ' folders which are more than the configured \'maxSubFoldersSize\' (' + maxRows +
            ') to be displayed');
        }
      });
      response.data.response.docs.map(function(doc) {
        var assignees = doc._data.aspects['atex.dam.standard.ContentAccess'].data.assignees;
        var owners = AssignService.getOwnersFromAssignees(assignees);
        var folderName = doc._data.aspects.contentData.data.name;
        var smartFolder = doc._data.aspects.contentData.data.smartFolder;
        var childNode = new DamFoldersNode(node, doc.id, folderName, owners, smartFolder);

        var values = atex.dam.AngularUtils.getTypeValues(doc, "_data/aspects/contentData/data/fields") || [];
        childNode.setTypes(values);
      });
    });
  };

  self.initializeTree = function(reset) {
    if (initInProgress) {
      return;
    }
    initInProgress = true;
    if (reset) {
      self.resetValues();
    }
    var deferred = $q.defer();
    DamService.getCurrentDamUserInfo().then(function(currentUserInfo) {
      self.setUserInfo(currentUserInfo);
      return ContentService.getContent({id: 'externalid/DeskRootFolder'});
    }). then (function(response) {
      self.resetTree();
      var assignees = response.data.aspects['atex.dam.standard.ContentAccess'] ? response.data.aspects['atex.dam.standard.ContentAccess'].data.assignees : undefined;
      var owners = AssignService.getOwnersFromAssignees(assignees);
      var rootNode = new DamFoldersNode(null, response.id, response.data.aspects.contentData.data.name, owners);
      rootNode.collapsed = true;
      rootNode.isRoot = true;
      self.rootNode = angular.copy(rootNode);
      self.moveRootNode = angular.copy(rootNode);
      // Check if the current user can see the root folder
      var canSee = self.userInfo.isAdm || AssignService.canUserSeeTheFolder(self.userInfo.externalId, self.userInfo.groups, assignees);
      self.hideRoot = !canSee;
      self.treemodel.push(self.rootNode);
      self.moveTreemodel.push(self.moveRootNode);
      if (self.hideRoot) {
        self.rootNode.collapsed = false;
        self.moveRootNode.collapsed = false;
        self.expandNode(self.rootNode).then(function(response) {
          self.expandNode(self.moveRootNode).then(function(response) {
            deferred.resolve();
          });
        });
      } else {
        deferred.resolve(self.rootNode);
      }
    }).then(null, function(error) {
      DamLocalizationService.translate("__FOLDERS_INIT_ROOT_ERROR_MSG__").then (function (message) {
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
      });
      deferred.reject(error);
    }).finally(function(){
      initInProgress = false;
    });
    return deferred.promise;
  };

  self.checkDimensionField = function(metadataAspect, dimensionId, validValues) {
    if (!validValues || validValues.length <= 0) {
      return true;
    }
    if (!metadataAspect) {
      return false;
    }
    var dimensions = atex.onecms.ObjectUtils.accessor(metadataAspect, 'data/metadata/dimensions').value;
    if (!dimensions || dimensions.length<=0) {
      return false;
    }
    var dimension = _.find(dimensions, function(_dimension) {
      return _dimension.id === dimensionId;
    });
    var found = false;
    if (dimension && dimension.entities) {
      dimension.entities.forEach(function(entity) {
        if (_.indexOf(validValues, entity.id) > -1) {
          found = true;
        }
      });
    }
    return found;
  };

  self.checkPublEventField = function(publEventsAspect, field, validValues) {
    if (!validValues || validValues.length <= 0) {
      return true;
    }
    if (!publEventsAspect) {
      return false;
    }
    var publEvents = atex.onecms.ObjectUtils.accessor(publEventsAspect, 'data/publevents').value;
    if (!publEvents || publEvents.length<=0) {
      return false;
    }
    var found = false;
    publEvents.forEach(function(publEvent) {
      if (_.indexOf(validValues, publEvent[field]) > -1) {
        found = true;
      }
    });
    return found;
  };

  self.checkPublEventPageField = function(publEventsAspect, validPages) {
    if (!validPages) {
      return true;
    }
    var validPagesArray = validPages.split(' ');
    if (!validPagesArray || validPagesArray.length<=0) {
      return true;
    }
    if (!publEventsAspect) {
      return false;
    }
    var publEvents = atex.onecms.ObjectUtils.accessor(publEventsAspect, 'data/publevents').value;
    if (!publEvents || publEvents.length<=0) {
      return false;
    }
    var found = false;
    publEvents.forEach(function(publEvent) {
      if (_.indexOf(validPagesArray, publEvent.page) > -1) {
        found = true;
      }
    });
    return found;
  };

  self.addContentToFolder = function(ids, node, copy) {
    var deferred = $q.defer();
    var idsLen = ids.length;
    var countNotMatch = 0;
    var countAlreadyIn = 0;
    var locked = false;

    var physicalParent = node.getPhysicalParent();
    var validTypes = [];
    DamActivityService.lock(ids).then(function(responses){
      locked = true;
      return ContentService.getContent({id: node.id});
    }).then(function(folder) {
      validTypes = node.getAllowedTypes();
      return $q.when(folder);
    }).then(function(folder) {
      var validStatus = atex.dam.AngularUtils.getFieldValues(folder, 'data/aspects/contentData/data/fields','content_status_id_s') || [];
      var validPartitions = atex.dam.AngularUtils.getFieldValues(folder, 'data/aspects/contentData/data/fields','tag_dimension.partition_ss') || [];
      var validPublications = atex.dam.AngularUtils.getFieldValues(folder, 'data/aspects/contentData/data/fields','publication_atex_desk_ss') || [];
      var validEditions = atex.dam.AngularUtils.getFieldValues(folder, 'data/aspects/contentData/data/fields','edition_atex_desk_ss') || [];
      var validPages = atex.dam.AngularUtils.getFieldValues(folder, 'data/aspects/contentData/data/fields','page_atex_desk_ss') || "";
      var validColorCoding = atex.dam.AngularUtils.getFieldValues(folder, 'data/aspects/contentData/data/fields','tag_dimension.markas-colorcoding_ss') || [];
      var validMultiIconCoding= atex.dam.AngularUtils.getFieldValues(folder, 'data/aspects/contentData/data/fields','tag_dimension.markas-multiiconcoding_ss')|| [];
      var validIconCoding = atex.dam.AngularUtils.getFieldValues(folder, 'data/aspects/contentData/data/fields','tag_dimension.markas-iconcoding_ss')|| [];
      var validSources = atex.dam.AngularUtils.getFieldValues(folder, 'data/aspects/contentData/data/fields','source_atex_desk_s')|| [];

      var getPromises = ids.map(function(id) {
        return ContentService.getContent({id:id}).then(function(response) {
          if (validTypes.length>0) {
            var currentType = atex.onecms.ObjectUtils.accessor(response.data, 'aspects/contentData/data/objectType').value;
            if (_.indexOf(validTypes, currentType)===-1) {
              countNotMatch++;
              return undefined;
            }
          }
          if (validStatus.length>0) {
            var currentStatus = atex.onecms.ObjectUtils.accessor(response.data, 'aspects/atex.WFContentStatus/data/status/statusID').value;
            if (_.indexOf(validStatus, currentStatus)===-1) {
              countNotMatch++;
              return undefined;
            }
          }
          if (!self.checkDimensionField(response.data.aspects['atex.Metadata'], "dimension.partition", validPartitions)) {
            countNotMatch++;
            return undefined;
          }
          if (!self.checkPublEventField(response.data.aspects['atex.dam.standard.Publevents'], 'publication', validPublications)) {
            countNotMatch++;
            return undefined;
          }
          if (!self.checkPublEventField(response.data.aspects['atex.dam.standard.Publevents'], 'edition', validEditions)) {
            countNotMatch++;
            return undefined;
          }
          if (!self.checkPublEventPageField(response.data.aspects['atex.dam.standard.Publevents'], validPages)) {
            countNotMatch++;
            return undefined;
          }

          if(!self.checkDimensionField(response.data.aspects['atex.Metadata'], "dimension.markas-colorcoding", validColorCoding)) {
            countNotMatch++;
            return undefined;
          }

          if(!self.checkDimensionField(response.data.aspects['atex.Metadata'], "dimension.markas-multiiconcoding", validMultiIconCoding)) {
            countNotMatch++;
            return undefined;
          }

          if(!self.checkDimensionField(response.data.aspects['atex.Metadata'], "dimension.markas-iconcoding", validIconCoding)) {
            countNotMatch++;
            return undefined;
          }

          if (validSources.length>0) {
            var currentSource = atex.onecms.ObjectUtils.accessor(response.data, 'aspects/contentData/data/source').value;
            if (_.indexOf(validSources, currentSource)===-1) {
              countNotMatch++;
              return undefined;
            }
          }

          var dirtySecParent = false;
          if (physicalParent) {
            dirtySecParent = atex.dam.AngularUtils.copySecInsParent(response, folder);
          }
          var dirtyFolder = false;
          if (!node.smartFolder) {
            dirtyFolder = atex.dam.AngularUtils.setFolder(response, node.id, node.buildPath(), copy);
          } else {
            // If the folder where we are adding contents is a smartFolder then try to get the first regular (physical) ancestor folder
            // in order to set the required parentDeskFolderId into the adding content [max]
            if (physicalParent) {
              dirtyFolder = atex.dam.AngularUtils.setFolder(response, physicalParent.id, physicalParent.buildPath(), copy);
            }
          }
          var dirtyMeta = atex.dam.AngularUtils.mergeMetadata(response, folder, configuration.getSingleValueDimensions());
          if (dirtyFolder || dirtySecParent || dirtyMeta) {
            return response;
          } else {
            countAlreadyIn++;
            return undefined;
          }
        });
      });
      return $q.all(getPromises);
    }).then(function(contents) {
      var savePromises = [];
      contents.map(function(content) {
        if (content) {
          var updateInfo = { id: content.id, data: content.data, revision: content.revision};
            savePromises.push(ContentService.updateContent(updateInfo).then(function(response) {
              return response;
            })
          );
        }
      });
      return $q.all(savePromises);
    }).then(function(contents) {
      var message;
      if (contents.length) {
        message = $translate.getTranslationTable().__FOLDERS_CONTENT_ADDED_MSG__;
        if (idsLen>1 && (countNotMatch>0 || countAlreadyIn>0)) {
          message += " (" + contents.length + ")";
        }
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'success', message: message }), false);
      }
      if (countNotMatch>0) {
        message = $translate.getTranslationTable().__FOLDERS_CONTENT_DOES_NOT_MATCH_MSG__;
        if (idsLen>1) {
          message += " (" + countNotMatch + ")";
        }
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'warning', message: message }), true);
      }
      if (countAlreadyIn>0) {
        message = $translate.getTranslationTable().__FOLDERS_CONTENT_ALREADY_IN_MSG__;
        if (idsLen>1) {
          message += " (" + countAlreadyIn + ")";
        }
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'warning', message: message }), true);
      }
      deferred.resolve(contents);
      DamActivityService.unlock(ids);
    }).then(null, function(error) {
      if (locked) {
        var message = $translate.getTranslationTable().__FOLDERS_CONTENT_ADDED_KO_MSG__ + " (" + error.cause + ")";
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
        DamActivityService.unlock(ids);
      }
      deferred.reject(error);
    });

    return deferred.promise;
  };

  var _calcolateFilterQuery = function(advanced) {
    if (typeof(advanced) !== "object") {
      return $q.when();
    }
    var query2Execute = angular.copy(advanced);
    query2Execute._type = "atex.dam.standard.Query";

    var fullTextField = _.find(query2Execute.fields, function(field) {
      return field.key === 'atex_desk_text';
    });
    if (fullTextField && fullTextField.values[0]) {
      // Temporary add 'AND' between terms in  atex_desk_text
      fullTextField.values[0] = DamService.normalizeQueryString(fullTextField.values[0]);
    }
    var queryContainer = {
      'container' : {
        'aspects' : {
          'contentData' : {
            'data' : query2Execute
          }
        }
      }
    };
    return DamService.getQuery(queryContainer.container).then(function(queryData) {
      return queryData.data.solr_query;
    });
  };

  /**
   * 'fullText' can be undefined or can be a simple string (real fullText search) or can be the advanced search model
   * in case it's the advanced we calculate a fq from the model and pass it as a filter query
   */
  self.executeQuery = function(folderNode, fullText) {
    var ts = Date.now();
    DamSearchService.setLastQueryStartTs(ts);
    ContentService.getContent({id: folderNode.id}).then(function(folder) {
      if (!DamSearchService.isStillLastQuery(ts)) {
        return $q.reject();
      }
      var isSmartFolder = atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/contentData/data/smartFolder').value;
      var isDynamic = fullText && fullText.isDynamic ? fullText.isDynamic : atex.onecms.ObjectUtils.accessor(folder.data, 'aspects/contentData/data/isDynamic').value;
      //clear button removes isDynamic property - in that case use the value displayed in adv search popup (false)
      if (typeof(fullText) === "object" && fullText.isDynamic === undefined) {
        isDynamic = false;
      }
      var folderMetadata = folder.data.aspects['atex.Metadata'];
      var folderInsInfo = folder.data.aspects['p.InsertionInfo'];
      if (!folderMetadata && isSmartFolder) {
        return;
      }
      var parentDeskFolderId;
      if (!folderNode.smartFolder) {
        parentDeskFolderId = folderNode.id;
      } else {
        // If the listing folder is a smartFolder then try to get the first regular (physical) ancestor folder
        // in order to set the required parentDeskFolderId into the query [max]
        var physicalParent = folderNode.getPhysicalParent();
        if (physicalParent) {
          parentDeskFolderId = physicalParent.id;
        }
      }
      var metadataQuery = "";
      if (parentDeskFolderId) {
        metadataQuery += "+tag_id_dimension.DeskFolders_ss:((" + _escape(parentDeskFolderId) + "))";
      }
      if (isSmartFolder && folderMetadata) {
        folderMetadata.data.metadata.dimensions.forEach(function(dimension) {
          if (!dimension.entities || dimension.entities.length<=0) {
              return;
          }
          var queryDim = "+tag_" + dimension.id + "_ss:(";
          dimension.entities.forEach(function(entity, index) {
            if (index>0) {
              queryDim += " OR ";
            }
            queryDim += "(" + _escape(atex.dam.AngularUtils.entityToPath(entity)) + ")";
          });
          queryDim += ")";
          metadataQuery += queryDim;
        });
      }
      if (parentDeskFolderId && folderInsInfo) {
        var secParent = folderInsInfo.data.securityParentId;
        secParent =  secParent.replace('contentid/','');
        metadataQuery += "+securityParentId_s:((" + _escape(secParent) + "))";
      }

      var query = {};
      query._type = "atex.dam.standard.Query";
      query.hiddenQuery = true;

      var types = folderNode.getAllowedTypes();
      if (!types || types.length <= 0) {
        types = DamService.getAllDeskObjType().split(" ");
      }

      atex.dam.AngularUtils.addTypeField(types, folder, "data/aspects/contentData/data/fields");

      query.includeTrash = folder.data.aspects.contentData.data.includeTrash;
      query.viewMode = folder.data.aspects.contentData.data.viewMode;

      query.metadataQuery = metadataQuery;
      query.isDynamic = isDynamic;

      // Set order
      var storedSortValue = folder.data.aspects.contentData.data.sortValue;
      var storedSortOrderValue = folder.data.aspects.contentData.data.sortOrderValue;
      query.sortValue = storedSortValue ? storedSortValue : $rootScope.damSortData.currentSortValue;
      query.sortOrderValue = storedSortOrderValue ? storedSortOrderValue : $rootScope.damSortData.currentSortOrderValue;

      var fields =  folder.data.aspects.contentData.data.fields;
      if (fields) {
        query.fields = fields;
      }

      folder.queryTs = ts;

      if (fullText) {
        folder.refiningFolderSearch = true;
        folder.fullText = fullText;
        if (typeof(fullText) !== "object") {
          query.fullText = fullText;
        } else {
          query.fullText = fullText.fullText;
        }
      } else {
        // Set fullText
        var _fullTxt = folder.data.aspects.contentData.data.fullText;
        if (_fullTxt) {
          query.fullText = _fullTxt;
        }
      }

      _calcolateFilterQuery(fullText).then(function(fq){
        if (!folder.refiningFolderSearch) {
          var currAdvQuery = DamSearchService.getCurrentAdvQuery();
          Object.keys(currAdvQuery).forEach(function(key) { delete currAdvQuery[key]; });
        }
        folder.advancedAsFolderFilter = fq;
        DamSearchService.advancedSearch(query, folder);
      });
    });
  };

  self.deleteFolder = function(folderId) {
    var deferred = $q.defer();
    ContentService.getContent({id: folderId})
    .then(function(response) {
      return ContentService.deleteContent({
        id: response.id,
        revision: response.revision
      });
    })
    .then(function(response) {
      deferred.resolve(response);
    })
    .then(null, function(error) {
      var message = $translate.getTranslationTable().__FOLDERS_DELETE_ERROR_MSG__ + " (" + error.cause + ")";
      DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
      deferred.reject(error);
    });
    return deferred.promise;
  };

  self.addFolder = function(parentNode, folder, collapsed) {
    var owners = AssignService.getOwnersFromAssignees(folder.data.aspects['atex.dam.standard.ContentAccess'].data.assignees);
    var childNode = new DamFoldersNode(parentNode, folder.id, folder.data.aspects.contentData.data.name, owners, folder.data.aspects.contentData.data.smartFolder);
    childNode.collapsed = collapsed;

    childNode.types = atex.dam.AngularUtils.getTypeValues(folder, "data/aspects/contentData/data/fields") || [];
  };

  //Handle login / logout
  $rootScope.$on("dam:logout", function() {
    self.resetValues();
  });
  $rootScope.$on("onecms:authenticationSuccess", function() {
    self.initializeTree(true);
  });

  self.resetSelection = function(dontClearAdvanced) {
    if (self.resettingSelection) {
      return;
    }
    self.resettingSelection = true;
    self.listingFolder = undefined;
    if (!dontClearAdvanced) {
      $rootScope.$broadcast("dam:clearFolderInfo");

    }
    self.resettingSelection = false;
  };

  $rootScope.$on("dam:resetFoldersSelection", function() {
    self.resetSelection(true);
  });

  self.initializeTree();

}]);
